import axios from 'axios';
import {getUserDetails} from '../actions/Auth';
import { TEST_SERVER_URL } from '../constants/Common';


export default axios.create({
  baseURL: `http://${TEST_SERVER_URL}:3002/v2/`,//YOUR_API_URL HERE //https when live and http when uat
  headers: {
    'Content-Type': 'application/json',
    'Authorization':'Bearer '+getUserDetails()?.TOKEN/// Added for security
  }
});
